<template>
    <div class="sellerPickerHolder">
        <multiselect v-model="selectedSeller" :options="options" :allowEmpty="false" :multiple="false" group-label="false" :showLabels="false" placeholder="Select" track-by="id" label="name" @input="update">
            <span slot="noResult">No results.</span>
        </multiselect>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
 import Multiselect from 'vue-multiselect'

export default {
    data: function() {
        return {
            options: [

            ],
            selectedOption: null,
        }
    },
    props:{
        reservation: {
            // this is not mandatory, this component can be used without a reservation
            // for that just use the @input event to get the selected seller
            // if a reservation is provided the component will update the that reservation
            default:null
        },
        orignalSeller: {
            default: null
        },
        agentList: {
            default: null
        },
        myTeamList: {
            default: null
        }
    },
    created: function() {
        this.downloadTeam(this.myTeamList)
    },
    computed: {
        ...mapGetters([
            'account'
        ]),
        selectedSeller: {
            // getter
            get: function () {
                if(this.selectedOption){
                    return this.selectedOption
                } else {
                    let output = this.orignalSeller
                    return output
                }
            },
            // setter
            set: function (newValue) {
                  this.selectedOption = newValue
            }
        }
    },
    methods: {
        downloadTeam: function(propMyTeam) {
            if(propMyTeam == null){
                axios.get('/api/supplier/memberList', {
                    params: {
                        supplierId: this.account.supplierId
                    }
                }).then(response => {
                    if(response.status == 200){
                        // this.$set(this.options[0], 'people', this.myTeamAddBrandName(response.data))
                        this.options = response.data
                    }
                })
            } else {
                this.options = response.data
            }
        },
        update: function(value) {
            if(value){
                this.$emit('input', value)
                if(this.reservation){
                    this.updateReservation(value)
                }
            }
        },
        updateReservation: function(newSeller){
            if(newSeller.commission){
                //is an agent
                this.reservation.creatorAgent = newSeller
                this.reservation.creatorUserAccount = null
                this.reservation.creatorSupplier = null
            } else {
                //is my team
                this.reservation.creatorAgent = null
                this.reservation.creatorUserAccount = newSeller
                this.reservation.creatorSupplier = this.account.supplier
            }
        },
        myTeamAddBrandName: function(inputArr){
            inputArr.map(row => {
                row.brandName = row.name
            })

            return inputArr
        }
    },
    components: {
        Multiselect
    }
}
</script>

<style lang="scss" scoped>
    .sellerPickerHolder{
        position: relative;
        z-index: 10;

        .multiselect__select{
            top:  8px !important;
        }

        .multiselect__tags{
            background: none !important;
            border: 0 !important;
        }
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// TeamMemberPicker.vue?236ce710